import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M10.567 1.09a1.835 1.835 0 0 0-1.134 0 1.86 1.86 0 0 0-.63.372c-.16.134-.335.31-.525.5L1.963 8.279c-.191.19-.367.366-.501.524a1.86 1.86 0 0 0-.372.631c-.12.369-.12.765 0 1.134.084.258.227.46.372.63.134.16.31.335.5.525l6.316 6.315c.19.191.366.367.524.501.171.145.373.288.631.372.369.12.765.12 1.134 0 .258-.084.46-.227.63-.372.16-.134.335-.31.526-.5l6.314-6.316c.191-.19.367-.366.501-.524.145-.171.288-.373.372-.631.12-.369.12-.765 0-1.134a1.859 1.859 0 0 0-.372-.63c-.134-.16-.31-.335-.5-.525l-6.316-6.315a9.471 9.471 0 0 0-.524-.501 1.86 1.86 0 0 0-.631-.372Zm.183 4.66a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 1.5 0v-3.5Zm0 7a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgAlertFill);
export { ForwardRef as ReactComponent };
